import { useClientContext } from 'context/ClientContext';
import { BiPageComp } from 'pages/bi/components';
import { InicioUsuarioInfo } from 'pages/inicio/components';

export function InicioDetailComp() {
    const { tipoPedido } = useClientContext();
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';
    const isTipoPedidoPadrao = tipoPedido === 'padrao';

    return (
        <>
            {isTipoPedidoFuncionario && <InicioUsuarioInfo />}

            {isTipoPedidoPadrao && <BiPageComp />}
        </>
    );
}
